<div class="draft-toolbar">
  <button
    *ngIf="canUndo"
    mat-icon-button
    (click)="undoClick.emit()"
    matTooltip="undo"
  >
    <mat-icon>undo</mat-icon>
  </button>

  <nz-tag *ngIf="draftClosed" nzColor="red">
    <i nz-icon nzType="lock" nzTheme="outline"></i>
    הטיוטה נעולה
  </nz-tag>

  <!-- Auto-save status indicator -->
  <span class="save-status" *ngIf="!readonly">
    <mat-spinner
      *ngIf="autoSaveStatus === 'saving'"
      [diameter]="20"
      color="primary"
    ></mat-spinner>
    <mat-icon *ngIf="autoSaveStatus === 'saved'" class="status-saved"
      >check_circle</mat-icon
    >
    <mat-icon
      *ngIf="autoSaveStatus === 'error'"
      class="status-error"
      matTooltip="שגיאה בשמירה"
      >error</mat-icon
    >
  </span>

  <button
    *ngIf="!readonly"
    nz-button
    nzGhost
    nzType="primary"
    [disabled]="!canFinish"
    (click)="finishClick.emit()"
  >
    סיים ונעל את הטיוטה
  </button>

  <button
    *ngIf="canReopen"
    nz-button
    nzGhost
    nzType="primary"
    (click)="reopenClick.emit()"
  >
    פתיחה מחדש
  </button>
</div>
